import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getProductDataRequest,
  getProductDataSuccess,
  getProductDataFailure,
} from "./productSlice";
import { toast } from "react-toastify";

function* fetchProductData(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/product/category-mobile`)
    );

    if (response.data.success) {
      yield put(getProductDataSuccess(response.data));
      toast.success(response.data.message);
    } else {
      yield put(
        getProductDataFailure(response.data.message || "Failed to fetch products")
      );
      toast.error(response.data.message || "Failed to fetch products");
    }
  } catch (error) {
    yield put(getProductDataFailure(error.message));
    toast.error("Error fetching products");
  }
}


export function* productSaga() {
  yield takeLatest(getProductDataRequest.type, fetchProductData);
}
